import { s as t, _ as d } from "./chunk-JJ6VZ5V7-dcb0df39.mjs";
import * as e from "react";
import { s as i, c as a } from "./lib-ed2ec51e.mjs";
import "@aircall/icons";
import "@aircall/tractor-v2";
import "styled-components";
import "react-router-dom";
import "@aircall/hooks";
import "react-final-form";
import "react-dom";
import "react-router";
import "final-form";
var c = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  d({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 32 32"
  }, l),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#2C97DE",
      fillRule: "evenodd",
      d: "M2.258 27.333h27.484c-.837 1.303-2.13 2.678-4.085 3.437-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23-1.953-.759-3.247-2.134-4.084-3.437Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M.34 10.667h31.343c.254 1.844.336 3.663.314 5.35a34.717 34.717 0 0 1-.337 5.316H.325a34.914 34.914 0 0 1-.322-5.35c-.022-1.66.074-3.469.337-5.316Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#2C97DE",
      fillRule: "evenodd",
      d: "M29.754 4.667H2.258c.837-1.303 2.13-2.678 4.085-3.438C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.691 1.263 1.937.752 3.226 2.11 4.063 3.404Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M10.333 21c2.394 0 4.334-2.239 4.334-5s-1.94-5-4.334-5C7.94 11 6 13.239 6 16s1.94 5 4.333 5Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#C2E7FF",
      fillRule: "evenodd",
      d: "M10.333 13H12v-.333c0-.368-.746-.667-1.667-.667-.92 0-1.667.299-1.667.667V13h1.667Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#C2E7FF",
      d: "M7.078 13.85a8.187 8.187 0 0 1 3.255-.65c1.156 0 2.24.217 3.255.65a.2.2 0 1 0 .157-.367 8.588 8.588 0 0 0-3.412-.683c-1.21 0-2.347.227-3.412.683a.2.2 0 1 0 .157.368Z"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#DCA842",
      fillRule: "evenodd",
      d: "M11.804 19.142c.37-.364 1.712-1.088 1.863-2.142.04-.276 0-1.082-.372-1.152-.232-.043-.472.185-.7.04-.229-.145-.225-.506 0-.661.224-.155.418 0 .413-.23-.118-.547-.575-.71-.287-.707.326-.093-1.124-.447-.673-.524.084-.116-.82-.433-1.198-.456.187-.24-.05-.31-.516-.31-.468 0-.705.07-.518.31-.378.023-1.282.34-1.198.456.451.077-1 .43-.673.524.288-.004-.169.16-.287.707-.005.23.189.075.414.23.224.155.228.516 0 .66-.229.146-.47-.082-.7-.039-.373.07-.412.876-.373 1.152.151 1.054 1.493 1.778 1.863 2.142.37.364.438.856 1.47.858 1.034-.002 1.102-.494 1.472-.858Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#C2E7FF",
      fillRule: "evenodd",
      d: "M8.337 16.007c.096-.32.144-.73.008-1.263.597-.385 1.017-.737 1.99-.737.971 0 1.43.267 1.99.737-.134.533-.086.942.009 1.263h-4",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#2C97DE",
      fillRule: "evenodd",
      d: "M8.336 16c-.054.21-.18.39-.239.543-.155.403-.187 1.34.384 2.003.848.981 1.494.586 1.819 1.12h.066c.325-.534.97-.139 1.819-1.12.57-.663.54-1.6.384-2.003-.058-.152-.185-.333-.24-.543H8.337Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#1AAF5D",
      fillRule: "evenodd",
      d: "M12.473 16.321c.063.153.192.354.192.679H8c.012-.064.016-.123.031-.198.414-.116.542-.417.717-.396.095-.144.556-1.245.79-1.405.183.23.546 1 .712 1.395.116-.093.634-1.122.697-1.235.062-.112.099-.165.183 0 .084.165.292.993.422 1.16 0 0 .32-1.16.386-1.16.134 0 .494 1.138.535 1.16Z",
      clipRule: "evenodd"
    }
  )
), o = i(c)`
  ${t}
  ${a}
`, C = o;
export {
  C as default
};
